<script setup lang="ts">
    import { computed, onMounted, ref, watch } from 'vue'
    import { SelectFieldSingle } from '@/js/components/Common'
    import { useStudiengangStore } from '@/js/stores'

    const studiengangStore = useStudiengangStore()

    const studiengaenge = computed(() => studiengangStore.studiengaenge)

    const emit = defineEmits(['studiengangSelected'])

    const studiengangSelectOptions = computed(() => [
        { value: null, title: 'Studiengang wählen ...', disabled: true },
        ...studiengaenge.value.map((studiengang) => {
            return {
                title: `${studiengang.kurzName} - ${studiengang.name}`,
                value: studiengang.studiengangId
            }
        })
    ])

    const selectedStudiengang = ref(null)

    watch(
        () => selectedStudiengang.value,
        () => {
            emit('studiengangSelected', selectedStudiengang.value)
        }
    )

    onMounted(async () => {
        emit('studiengangSelected', selectedStudiengang.value)
    })
</script>

<template>
    <div v-if="studiengangStore.studiengaenge.length" class="d-flex align-center">
        <select-field-single
            v-model="selectedStudiengang"
            :items="studiengangSelectOptions"
            label="Studiengang"
            placeholder="Studiengang wählen"
            data-test="select-studiengang"
            min-width="300px"
        />
    </div>
</template>

<script></script>

<style scoped></style>
